export default "__VITE_ASSET__CJdfr7cx__"